module.exports = __webpack_public_path__ + "img/5-1.767d38e6.png";